import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccountComponent } from 'app/account/account.component';
import { LoginComponent } from 'app/account/login/login.component';
import { RegisterComponent } from 'app/account/register/register.component';
import { FullLayoutComponent } from '../containers';
import { AuthGuard } from './auth.guard';
import { ChangePasswordComponent } from './change-password/change-password.component'
import { ResetPasswordComponent } from './resetpassword/resetpassword.component';

const routes: Routes = [{
  path: '',
  component: FullLayoutComponent,
  data: {
    title: 'Account'
  },
  children: [{
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register'
    }
  },
  {
    path: 'changepassword',
    canActivate: [AuthGuard],
    component: ChangePasswordComponent,
    data: {
      title: 'Change Password',
      roles: ['Authenticated User']
    }
  },
  {
    path: 'resetpassword',
    component: ResetPasswordComponent,
    data: {
      title: 'Reset Password'
    }
  }
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountRoutingModule { }



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/account/account-routing.module.ts